var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("h1", { staticClass: "mt-2 mb-4" }, [_vm._v("Forgot Password")]),
    _vm._v(" "),
    _c("div", { staticClass: "pb-20 h-screen w-full md:w-1/2" }, [
      _c("div", { ref: "email", staticClass: "mt-6" }, [
        _c("p", { staticClass: "mt-3 mb-10" }, [
          _vm._v(
            "Enter your email address below and we'll send you a password reset link."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { method: "POST", "aria-label": "Forgot Password" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { class: { "mb-4": true, "has-error": _vm.errors.has("email") } },
            [
              _c(
                "label",
                {
                  staticClass: "text-h3 font-sans-bold",
                  attrs: { for: "email" },
                },
                [_vm._v("Email Address")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'",
                  },
                ],
                attrs: { id: "email", type: "email", name: "email" },
                domProps: { value: _vm.form.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("email"),
                        expression: "errors.has('email')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("email")))]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("button", { staticClass: "button", attrs: { type: "submit" } }, [
            _vm._v("\n                  Send reset link\n              "),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }